import React, {useEffect, useState} from 'react';
import {useAppBridge} from '@shopify/app-bridge-react';

// types
import {Intent, PlainObject} from '~/types/shopify.types';
import PersonalLetterPlain from '~/pages/plain/PersonalLetter';

const PersonalLetter: React.FC<React.PropsWithoutRef<any>> = () => {
  const shopify = useAppBridge();
  const [intent, setIntent] = useState<Intent | PlainObject>({});

  useEffect(() => {
    const cleanup = shopify.intents.register(setIntent);

    return () => cleanup();
  }, [shopify.intents]);

  return (
    <PersonalLetterPlain
      intent={(intent as Intent)}
      onComplete={fields => intent.finish(fields)}/>
  );
};

export default PersonalLetter;
